import { EmployeeRolesEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class UnitRequest {
    @ApiProperty()
    unitId: number;
    @ApiProperty()
    role?: EmployeeRolesEnum;
    @ApiProperty()
    state?:string;
    constructor(unitId: number, role?: EmployeeRolesEnum,state?:string) {
        this.unitId = unitId;
        this.role = role;
        this.state = state;
    }
}